import { HeaderText } from '@components/Layout/HeaderText';
import { Chip, Stack } from '@mui/material';
import { Download } from './Download';

type HeaderProps = {
  campaignId: number;
  campaignName: string;
  brand: string | null;
};

export const Header = (props: HeaderProps) => {
  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center" gap="0.5rem">
        <HeaderText>{props.campaignName}</HeaderText>
        {props.brand ? <Chip size="small" label={props.brand} /> : null}
      </Stack>
      <Download
        campaignId={props.campaignId}
        campaignName={props.campaignName}
      />
    </Stack>
  );
};
